import React from "react";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useState } from "react";

export const CookiesPopup = () => {
  const [showCookiesPopup, setShowCookiesPopup] = useState(true);
  const [cookiesAllowed, setCookieAllowed] = useState(false);

  const onAllowHandler = () => {
    Cookies.set("onezapp-cookies", "true", { expires: 30 });
    setShowCookiesPopup(false);
  };

  useEffect(() => {
    if (Cookies.get("onezapp-cookies")) {
      setCookieAllowed(true);
    }
  }, []);
  const handleClose = () => {
    setCookieAllowed(false);
    setShowCookiesPopup(false);
  };
  return (
    <>
      {showCookiesPopup && !cookiesAllowed ? (
        <div className="cookies-popup">
          <h2>Do you allow us to use cookies ?</h2>
          <p>
            We use cookies to learn where you struggle when you're naviating our
            website and fix them for your future visit.
          </p>
          <div className="d-flex justify-content-end px-4">
            <button
              className="btn btn-secondary me-2"
              onClick={() => handleClose()}
            >
              Decline
            </button>
            <button className="btn btn-primary" onClick={onAllowHandler}>
              Allow all
            </button>
            {/* <Lottie
              loop
              animationData={Promo}
              play
              style={{ width: 150, height: 150 }} */}
            {/* /> */}
          </div>
        </div>
      ) : null}
    </>
  );
};
